import axios from 'axios';

let prefix = "/quest"

const QuestApi = {
	listQuest(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getQuestInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveQuest(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createQuest(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateQuest(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default QuestApi;